import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const TestPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 4, textAlign: 'center' }}>
      <Typography variant="h3" gutterBottom>
        測試頁面
      </Typography>
      <Typography variant="body1" paragraph>
        如果您能看到這個頁面，說明路由配置正常工作。
      </Typography>
      <Button 
        variant="contained" 
        color="primary" 
        onClick={() => navigate('/')}
        sx={{ mr: 2 }}
      >
        返回首頁
      </Button>
      <Button 
        variant="contained" 
        color="secondary" 
        onClick={() => navigate('/favorite')}
      >
        前往收藏頁
      </Button>
    </Box>
  );
};

export default TestPage; 